import { useCallback } from 'react';

import { Button } from '@bambi/component-library/src/components/Button';
import { CloudArrowDownIcon } from '@heroicons/react/24/outline';

import { useAppDispatch } from 'src/app/store/hooks';
import { useLazyGetPassengersExportAsCsvQuery } from 'src/common/external/bambi-api/emptyApi';
import { show } from 'src/common/primitives/Toast/toast.slice';
import formatServerError from 'src/common/util/serverErrorFormatter';

export function PassengerExportButton() {
  const [exportPassengers, { isLoading }] =
    useLazyGetPassengersExportAsCsvQuery();
  const dispatch = useAppDispatch();

  const handleExportPassengers = useCallback(async () => {
    try {
      await exportPassengers({}).unwrap();
    } catch (error) {
      dispatch(
        show({
          title: 'Error exporting passengers',
          description: formatServerError(error),
          type: 'error',
        })
      );
    }
  }, [dispatch, exportPassengers]);

  return (
    <Button
      variant="primary-outline"
      onClick={handleExportPassengers}
      loading={isLoading}
      disabled={isLoading}
    >
      <CloudArrowDownIcon className="mr-1 w-5" />
      Export Passengers
    </Button>
  );
}
